import { useResource } from "../../../Hooks/UseResource";

const useStaticData = () => {
  const [resourceError, loading, getData, postData] = useResource();

  const getLookupData = (lookupName, filterString) => {
    if (lookupName === "country") {
      return getData({ url: "/public/country" });
    } else if (lookupName === "tagValue") {
      return getData({
        url: "public/tagName/:tagName/get-tag-values",
        params: { tagName: "IDPROOF" },
      });
    } else if (lookupName === "tagValues") {
      return getData({
        url: "public/tagName/:tagName/get-tag-values",
        params: { tagName: "ADDPROOF", name: "Arun", id: 1 },
      });
    } else if (lookupName === "salutations") {
      return getData({
        url: "/public/tagName/:tagName/get-tag-values",
        params: { tagName: "SALUTATION" },
      });
    } else if (lookupName === "relationship") {
      return getData({
        url: "/public/tagName/:tagName/get-tag-values",
        params: { tagName: "RELATIONSHIP" },
      });
    } else if (lookupName === "nomineeRelationship") {
      var isMinor = filterString ? filterString : false;
      return getData({
        url: "/public/get-nominee-relationship-tag-values/:isMinor/is-minor",
        params: { isMinor: isMinor },
      });
    } else if (lookupName === "guardianRelationship") {
      return getData({
        url: "/public/tagName/:tagName/get-tag-values",
        params: { tagName: "GUARDIANRELATIONSHIP" },
      });
    } else if (lookupName === "state") {
      var countryId = filterString ? filterString : 0;
      return getData({
        url: "public/country/:countryId/states-for-country",
        params: { countryId: countryId },
      });
    } else if (lookupName === "stateShortName") {
      return getData({
        url: "/public/country/:countryShortName/get-states-by-country-short-name",
        params: { countryShortName: "INDIA" },
      });
    } else if (lookupName === "gender") {
      return getData({
        url: "/public/tagName/:tagName/get-tag-values",
        params: { tagName: "GENDER" },
      });
    } else if (lookupName === "occupationType") {
      return getData({
        url: "/public/tagName/:tagName/get-tag-values",
        params: { tagName: "OCCPATIONTYPE" },
      });
    } else if (lookupName === "educationalQualifications") {
      return getData({
        url: "/public/tagName/:tagName/get-tag-values",
        params: { tagName: "EDUQUALIFICATION" },
      });
    } else if (lookupName === "incomeLevel") {
      return getData({
        url: "/public/tagName/:tagName/get-tag-values",
        params: { tagName: "INCOMELEVEL" },
      });
    } else if (lookupName === "natureOfExposure") {
      return getData({
        url: "/public/tagName/:tagName/get-tag-values",
        params: { tagName: "NATUREOFPOLEXP" },
      });
    } else if (lookupName === "addressProof") {
      return getData({
        url: "/public/tagName/:tagName/get-tag-values",
        params: { tagName: "ADDPROOF" },
      });
    } else if (lookupName === "accountType") {
      return getData({
        url: "/public/tagName/:tagName/get-tag-values",
        params: { tagName: "ACCOUNTTYPE" },
      });
    } else if (lookupName === "accountTypeExcludeCode") {
      return getData({
        url: "/public/tag-name/:tagName/code/:code/get-tag-values",
        params: { tagName: "ACCOUNTTYPE", code: "CURRENT" },
      });
    } else if (lookupName === "accountTypeForResidentialStatus") {
      var residentialStatus = filterString ? filterString : "-1";
      return getData({
        url: "/public/get-bank-account-type-tag-values/:residentialStatus/residential-status",
        params: { residentialStatus: residentialStatus },
      });
    } else if (lookupName === "bank") {
      return getData({ url: "/public/bank" });
    } else if (lookupName === "countryByCountryNames") {
      var list = "UNITED STATES OF AMERICA (USA),CANADA";
      return getData({
        url: "/public/country-by-list",
        params: { shortNameList: list },
      });
    } else if (lookupName === "CountryListException") {
      var list = "UNITED STATES OF AMERICA (USA),CANADA,INDIA";
      return getData({
        url: "/public/country-not-in-list",
        params: { shortNameList: list },
      });
    } else if (lookupName === "relatedToPepPoliticalExposure") {
      return getData({
        url: "/public/tagName/:tagName/get-tag-values",
        params: { tagName: "RELATEDTOPEPPOLICALEXPOURE" },
      });
    } else if (lookupName === "mobileCountry") {
      return getData({ url: "/public/get-all-mobile-country" });
    } else if (lookupName === "ifscBranch") {
      var bankId = filterString ? filterString : 0;
      return getData({
        url: "/public/get-all-branch-by-bank",
        params: { bankId: bankId },
      });
    } else if (lookupName === "countryForNominee") {
      var residentialStatus = filterString ? filterString : "-1";
      return getData({
        url: "/public/get-country/:residentialStatus/residential-status",
        params: { residentialStatus: residentialStatus },
      });
    } else if (lookupName === "countryCodeForNominee") {
      var residentialStatus = filterString ? filterString : "-1";
      return getData({
        url: "/public/get-country/:residentialStatus/mobile-country-code",
        params: { residentialStatus: residentialStatus },
      });
    } else if (lookupName === "kycSetting") {
      var settingName = filterString ? filterString : 0;
      return getData({
        url: "/public/settingName/:settingName/get-settings-values",
        params: { settingName: settingName },
      });
    } else if (lookupName === "impairmentType") {
      return getData({
        url: "/public/tagName/:tagName/get-tag-values",
        params: { tagName: "IMPAIRMENTTYPE" },
      });
    } else if (lookupName === "skInternal") {
      return getData({ url: "/public/sk-internal" });
    } else if (lookupName === "kycConfig") {
      return getData({ url: "/public/kyc-settings-pre-login" });
    }
  };
  return [loading, getLookupData];
};

export default useStaticData;
